import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  collectErrors,
  getHasErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  isStatusCoordinator,
  isStatusCancelled,
} from 'AppSrc/core/crq/crq-statuses';
import { PEER_APPROVED_TYPE } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-constants';
import { formDataFromServerShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { CancelledStatusBar } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/cancelled-status-bar';
import { SummaryError, SiaImportError } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/summary-error';
import { InfoIcon, InfoIconSIA } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/info-icon';
import {
  hasPeerRejectionWii,
  getCancelationData,
  hasServiceImpAssRemedyAtCR,
  getWiiMetadata,
  // hasRemedyUploadFailedSerImAss,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-logic';
// import { ViewCrqCommsSummaryReview } from './view-crq-comms-summary';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-screen.css';
// import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
// import {
//   nowInDefaultTZ,
// } from 'AppSrc/core/utility-functions/date-functions';
import {
  getFormDataFieldValue,
  getFieldValueForParameters,
  getIsInternationalCrq,
  isCrqEmergency,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { approvalCommSLA } from 'AppSrc/core/components/forms/form-types/create-crq/crq-approval-comm-sla';
import { mobileApprovalCommSLA } from 'AppSrc/core/components/forms/form-types/create-crq/mobile-comms-approval-sla';
import {
  CHANGE_QUESTIONS,
  WORK_INFORMATION_ITEMS,
  // START_AND_END_DATE,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  COORDINATOR,
  CRB_APPROVER_GROUP,
  MOBILE_COMMUNICATIONS_CHECK,
  CHANGE_MANAGEMENT,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import {
  FIXED,
  MOBILE,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { scheduledStartDate } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/scheduled-start-date';
import { selectChangeSlaId } from 'AppSrc/core/components/forms/form-types//create-crq/section-two/section-two-constants';
import { impact } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/impact';
import { getNextBusinessDays, getNextHours } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/section-three-data-layer-functions';
// import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import { SectionError } from 'AppSrc/core/components/forms/section-error';
import { MobileIndividualApprovers } from 'AppSrc/core/components/forms/form-base-components/utility/add-additional-approver-mobile';
import { ViewCrqSectionSummary } from './view-crq-section-summary';
import { ViewCrqApprovalsHistory } from './view-crq-approvals-history';
import { ViewCrqCompletionReview } from './view-crq-completion-review';
// import { ViewCrqSectionSummary } from './view-crq-section-summary';
// import { ViewCrqApprovalsHistory } from './view-crq-approvals-history';
// import { ViewCrqCompletionReview } from './view-crq-completion-review';
import { ViewCrqMetadata, getImpactLevelDisplay } from './view-crq-metadata';
import { WorkflowBar } from './workflow-bar';
import { ViewCrqSelectPeerReviewer } from './view-crq-select-peer-reviewer';
import { ViewCrqNav } from './view-crq-nav';
import { ViewCrqTabs } from './view-crq-tabs';
import {
  VIEW_TYPE_VIEW_CRQ_WITH_TICKS_AND_ERRORS,
  VIEW_TYPE_VIEW_CRQ_STANDARD,
  TAB_SECTION_SUMMARY,
  TAB_APPROVALS_HISTORY,
  TAB_COMPLETION_REVIEW,
  TAB_COMMS_SUMMARY,
} from './view-crq-constants';
// import 'AppSrc/core/style/components/view-crq-screen/view-crq-screen.css';
// import { ViewCrqAddApprovers } from './view-crq-add-approvers'; commenting it out as of now because it's a part of phase3 release.
import { ViewCrqAddApprovers } from './view-crq-add-approvers';
import { ViewCrqActions } from './view-crq-actions';
import { ViewCrqCommsSummary } from './view-crq-comms-summary';
import { AssignToMeContent } from './assign-to-me';
import { ViewCrqCreateRelatedNetwork } from './view-crq-create-related-network';

const getallSectionsRead = (formData, summarySectionsRead, isChangeAnalyst) => {
  let allSectionsRead = false;
  const statusReason = formData.statusReason;
  const isWorkInfoItem = window.localStorage.getItem('isInfoItem');
  if (isChangeAnalyst === true && statusReason === '10500') {
    formData.formSectionsByDisplayOrder.forEach((formSectionId) => {
      const workInfoItem = 'WORK_INFORMATION_ITEMS';
      if (summarySectionsRead[workInfoItem] === true) {
        if (isWorkInfoItem === 'true') {
          allSectionsRead = true;
          return allSectionsRead;
        }
        allSectionsRead = false;
        // return allSectionsRead;
      }
      return allSectionsRead;
    });
  }
  else {
    allSectionsRead = true;
    formData.formSectionsByDisplayOrder.forEach((formSectionId) => {
      if (summarySectionsRead[formSectionId]) {
        return null;
      }
      allSectionsRead = false;
      return null;
    });
  }
  return allSectionsRead;
};

// Create 2nd flag for Emergency 2d Journey
const hasEmergenctL3Approvalwii = (formData, network) => {
  if (!formData) { return false; }
  const wiis = getWiiMetadata(formData);
  const approvalType = PEER_APPROVED_TYPE[network];
  return wiis.some((wii) => wii.type === approvalType);
};

const ViewCrqScreenContentUnconnected = ({
  crqId,
  network,
  formData,
  userRoles,
  remedyId,
  history,
  summarySectionsRead,
  viewCrqPowers,
  approvalsContext,
  isChangeAnalyst,
  userLoggedIn, // info of the Logged In User
  changeAnalystCircuitCheckID, // info of the Circuit Check Analyst
  fetching,
  notificationCommsSummaryData,
  userGroups,
  remedyRefFormData,
}) => {

  const defaultTab = approvalsContext ? TAB_APPROVALS_HISTORY : TAB_SECTION_SUMMARY;
  const [openedTab, setTab] = useState(defaultTab);
  const isCrqInfo = (openedTab === TAB_SECTION_SUMMARY) ? true : false;
  // for dealing view-crq-nav while performing crq-actions in approval stage.
  const [isCancelChecked, setIsCancelChecked] = useState(false);
  const [isPostponeChecked, setIsPostponeChecked] = useState(false);
  const [isMobileYesFlag, setIsMobileYesFlag] = useState('No');
  const [isApproverAssigned, setIsApproverAssigned] = useState(false);
  // const dispatch = useDispatch();
  const {
    status,
    statusReason,
    coordinatorName,
    coordinatorId,
    peerReviewerName,
    peerReviewerId,
    requesterName,
    summaryErrors,
    requester,
    coordinatorGroup, // adding coordinatorGroup in formData.
    dataByFormSectionId,
    postponeReason1,
    postponeReason2,
    postponeReason3,
    otherLineOperator, // To check OLO
    adjacentRemedyRef,
  } = formData;
  const {
    canEditForm,
    canViewErrors,
    canViewSectionsRead,
    canSubmitForm,
    canAddApprovers,
    canViewCompletionReview,
  } = viewCrqPowers;
  // const {
  //   dateCreated,
  // } = formData;
  // const defaultTab = TAB_SECTION_SUMMARY;
  // const [openedTab, setTab] = useState(defaultTab);

  // for dealing view-crq-nav while performing crq-actions in approval stage.
  const enableCancelApproval = (params) => {
    setIsCancelChecked(params);
    return true;
  };

  // for dealing view-crq-nav while performing crq-actions in approval stage.
  const enablePostponeApproval = (params) => {
    setIsPostponeChecked(params);
    return true;
  };

  useEffect(() => {
    if (approvalsContext) {
      setTab(TAB_APPROVALS_HISTORY);
    }
    if (canViewCompletionReview) {
      setTab(TAB_COMPLETION_REVIEW);
    }
  }, [approvalsContext, canViewCompletionReview]);
  const {
    START_AND_END_DATE,
  } = dataByFormSectionId;
  const isoDate = new Date().toISOString();
  const isScheduleDate = (isoDate < START_AND_END_DATE.dataByFieldId['scheduled-start-date'].value);

  const isInCancelledStatus = isStatusCancelled(status);
  const isInCoordinatorReviewStatus = isStatusCoordinator(status);
  const rejectedFromPeer = hasPeerRejectionWii(formData, network);
  const cancellationData = isInCancelledStatus ? getCancelationData(formData, network) : null;
  const userRole = userRoles[network];
  const hasViewableErrors = canViewErrors && summaryErrors;
  window.sessionStorage.setItem('relatedStatus', remedyRefFormData.status);
  const isEmergencyCrq = isCrqEmergency(formData);
  const isEmergency2ndJourney2 = hasEmergenctL3Approvalwii(formData, network);
  // we don't show errors if cancelled
  const errors = (hasViewableErrors) ? collectErrors({
    formData,
  }) : null;

  const hasErrors = errors ? getHasErrors(errors) : false;
  // Showing New remainder Icon for rejected CRQs
  const showInfoIconCondition = ((statusReason === 'Peer Rejected' || statusReason === 'Approval Rejected') && status === '3') || ((statusReason === '30100' || statusReason === '30200') && status === '3');
  const showInfoIcon = showInfoIconCondition ? true : false;
  // const hasRefFlag = true;
  const allSectionsRead = getallSectionsRead(formData, summarySectionsRead, isChangeAnalyst);
  const hasPeerReviewer = formData ? Boolean(formData.peerReviewerId) : false;
  const readyToSubmit = status === '4' ? !hasErrors && allSectionsRead && hasPeerReviewer : !hasErrors && allSectionsRead;
  const changeDetails = 'CHANGE_DETAILS';
  // Temporarily, if services are olo, then we are enabling submit button and considering it as an olo CRQ.
  // We will revert this change once we have permanent fix for otherLineOperator value which is currently coming incorrect.
  const oloServicesValue = formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value;
  const isOloService = (oloServicesValue === 'Network: Other Licensed Operator (OLO)' || oloServicesValue === 'Network: International Other Licensed Operator (OLO)');
  let canSubmitToPeer = ((otherLineOperator === 'Yes' || isOloService) || (network === 'mobile' && (status === '3' || status === '5') && (adjacentRemedyRef !== null || adjacentRemedyRef !== undefined))) ? canSubmitForm && readyToSubmit : canSubmitForm && readyToSubmit && hasPeerReviewer;
  const viewType = (canViewSectionsRead || canViewErrors) ? VIEW_TYPE_VIEW_CRQ_WITH_TICKS_AND_ERRORS : VIEW_TYPE_VIEW_CRQ_STANDARD;

  const impactValue = getImpactLevelDisplay(formData);
  const isCoordinator1 = userRole === COORDINATOR;
  const isAssignedCoordinator = isCoordinator1 && (remedyId === coordinatorId);
  const isAssignedPeerReviewer = isCoordinator1 && (remedyId === peerReviewerId);
  // show crq action if vine get postponed manually
  // eslint-disable-next-line camelcase
  const refStatusReason = remedyRefFormData.status_reason;
  const refStatus = remedyRefFormData.status;
  // update network group array if matches for crq actions for CM user
  let activeNetworkGroup;
  if (network === 'fixed' && userGroups[FIXED]) {
    activeNetworkGroup = userGroups[FIXED];
  }
  else if (network === 'mobile' && userGroups[FIXED]) {
    activeNetworkGroup = userGroups[MOBILE];
  }
  else {
    activeNetworkGroup = [];
  }
  const isCoordinatorFromCMGroup = activeNetworkGroup.length > 0 && activeNetworkGroup.includes(CHANGE_MANAGEMENT);
  // We have many conditions for this view earliear it was const but change to let for easyness
  let showCrqAction = ((((network === 'mobile') && adjacentRemedyRef === null || adjacentRemedyRef === undefined || (refStatus === '3' && refStatusReason === '30300')) || (network === 'fixed')) && isAssignedCoordinator && !isAssignedPeerReviewer && isScheduleDate && (status === '4' || status === '5' || status === '6' || status === 'Scheduled For Review' || status === 'Scheduled For Approval' || status === 'Scheduled'));
  // to show all CM coordinator
  showCrqAction = (isCoordinatorFromCMGroup && (Object.keys(remedyRefFormData).length === 0) && (status === '5' || status === 'Scheduled For Approval')) ? true : showCrqAction;
  const showCrqActionBypass = ((network === 'mobile') || (network === 'fixed')) && isAssignedCoordinator && !isAssignedPeerReviewer && (status === '7' || status === 'Implementation In Progress');
  const riskValue = formData.riskValue;
  const slaType = getFieldValueForParameters({
    formData,
    sectionId: CHANGE_QUESTIONS,
    fieldId: selectChangeSlaId,
  });

  const impactLevel = getFormDataFieldValue({
    formData,
    sectionId: CHANGE_QUESTIONS,
    fieldId: impact.id,
  });

  const scheduleStartDate = getFormDataFieldValue({
    formData,
    sectionId: 'START_AND_END_DATE',
    fieldId: scheduledStartDate.id,
  });
  const isIcmCrq = getIsInternationalCrq(formData);

  // For SIA validation at Circuit check stage
  const serImpAssRemedyFlagAtCR = false;
  let getRemedyFailedStatusCR = false;
  // let getRemedyCompleteStatusCR = false;
  if (status === '4' && statusReason === '10500') {
    // Get latest string for notes from Service Impact Assesment at circuit check stage
    const getWIIData = getFormDataFieldValue({
      formData,
      sectionId: WORK_INFORMATION_ITEMS,
      fieldId: 'work-information-items',
    });
    // Func will return 2 object at CR stage if SIA validation get pass or failed
    const {
      latestGeneralInfoSuccess,
      latestGeneralInfoFailed,
    } = hasServiceImpAssRemedyAtCR(getWIIData);
    getRemedyFailedStatusCR = latestGeneralInfoFailed;
    // this is for if user seesions logout
    if (latestGeneralInfoSuccess) {
      window.localStorage.setItem('isInfoItem', true);
    }

    if (latestGeneralInfoFailed) {
      window.localStorage.setItem('isInfoItem', false);
    }

    canSubmitToPeer = latestGeneralInfoSuccess === true ? true : false;
    // canSubmitToPeer = true;
  }

  const isFixedCoordinator = () => userRoles[FIXED] === COORDINATOR;
  const isMobileCoordinator = () => userRoles[MOBILE] === COORDINATOR;
  const isFixedCRBApprover = () => userGroups[FIXED] && userGroups[FIXED].includes(CRB_APPROVER_GROUP);
  const isMobileCommsApprover = () => userGroups[MOBILE] && userGroups[MOBILE].includes(MOBILE_COMMUNICATIONS_CHECK);
  const hasApproverAssigned = (param) => setIsApproverAssigned(param);

  const getCrqApprovalBasedOnSLA = () => {
    const commSLANetwork = approvalCommSLA[network] ? approvalCommSLA[network] : null;
    const commSLAType = commSLANetwork ? approvalCommSLA[network][slaType] : null;
    const commSLADays = commSLAType ? approvalCommSLA[network][slaType][impactLevel] : null;
    const getNextBusinessDayss = commSLADays ? getNextBusinessDays(scheduleStartDate, commSLADays) : false;
    // const leadDays = StartDateValidation ? getFullBusinessDays(nowInDefaultTZ(), scheduleStartDate) : null;
    // const LastDate = approvalcommsSLADate(getNextBusinessDayss);
    // const StartDateValidations = approvalcommsSLADate(LastDate);
    // console.log('new Data', commSLAType, commSLADays, LastDate, getNextBusinessDayss, StartDateValidations);
    // console.log(`network->${network}, slaType->${slaType}, impactLevel->${impactLevel}, scheduleStartDate->${scheduleStartDate}, commSLADays->${commSLADays}, leadDays->${leadDays}, businessdays -> ${getFullBusinessDays(nowInDefaultTZ(), scheduleStartDate)}`);
    // if (leadDays) {
    //   console.log('SLA fixed', commSLADays && (leadDays >= commSLADays));
    //   return commSLADays && (leadDays >= commSLADays);
    // }
    return getNextBusinessDayss;
  };

  const getMobileCrqApprovalBasedOnSLA = () => {
    const commSLANetwork = mobileApprovalCommSLA[network] ? mobileApprovalCommSLA[network] : null;
    const commSLAType = commSLANetwork ? mobileApprovalCommSLA[network][slaType] : null;
    const commSLADays = commSLAType ? mobileApprovalCommSLA[network][slaType][riskValue] : null;
    // const leadDays = commSLADays ? getFullBusinessDays(scheduleStartDate, nowInDefaultTZ()) : null;
    // console.log('mcom', commSLANetwork, 'commSLANetwork', commSLAType, 'commSLAType', commSLADays, 'commSLADays', leadDays, scheduleStartDate, network, impactLevel, riskValue, slaType);
    // console.log(`network->${network}, slaType->${slaType}, impactLevel->${impactLevel}, scheduleStartDate->${scheduleStartDate}, commSLADays->${commSLADays}, leadDays->${leadDays}, businessdays -> ${getFullBusinessDays(nowInDefaultTZ(), scheduleStartDate)}`);
    // if (leadDays) {
    //   console.log('mcom2', commSLADays && (leadDays <= commSLADays));
    //   return commSLADays && (leadDays <= commSLADays);
    // }
    // return true;
    let isExpedict = false;
    if (slaType === 'Expedited') {
      const gethours = getNextHours(scheduleStartDate);
      isExpedict = gethours;
      return isExpedict;
    }
    const getNextBusinessDayss = commSLADays ? getNextBusinessDays(scheduleStartDate, commSLADays) : false;
    return isExpedict === true ? true : getNextBusinessDayss;
  };

  // Using callback function set Vine flag and pass to view-crq-nav component
  const isCreateMobileCrq = (hasFlag) => {
    setIsMobileYesFlag(hasFlag);
  };

  // To set Adjacent Remedy Ref crq id to session storage if has
  const setAdjacentremedyRef = () => {
    const getCurrentAdjacentID = adjacentRemedyRef === undefined ? null : adjacentRemedyRef;
    window.sessionStorage.setItem('getCurrentAdjacentRemedyRef', getCurrentAdjacentID);
    if (status === '5' || status === '3' || status === '6' || network === 'mobile') {
      // Once vine has been created and move to approver stage remove sessionstorage to avoide concflict on upsert api param
      window.sessionStorage.removeItem('relatedCRQId');
      window.sessionStorage.removeItem('siaAddedAtCircuitCheck');
      window.sessionStorage.removeItem('statusReason');
      window.sessionStorage.removeItem('vineCheckPoint');
    }
  };
  setAdjacentremedyRef();

  // Check has related remedy Id or not for flag
  const hasReferenceCRQ = () => {
    console.log('hasramedy inner', adjacentRemedyRef);
    return ((adjacentRemedyRef === null) || (adjacentRemedyRef === undefined)) ? false : true;
  };

  const getInfoMessageFlag = window.sessionStorage.getItem('siaAddedAtCircuitCheck');
  const isInternationalCrq = getIsInternationalCrq(formData);

  const commSLACanApprove = isFixedCoordinator() && isFixedCRBApprover() && getCrqApprovalBasedOnSLA();
  const mobileCommSLACanApprove = isMobileCoordinator() && isMobileCommsApprover() && getMobileCrqApprovalBasedOnSLA();

  return (
    <div className="view-crq-content">
      <ViewCrqMetadata
        formData={formData}
      />
      <WorkflowBar
        status={status}
        crqId={crqId}
        coordinatorName={coordinatorName}
        coordinatorGroup={coordinatorGroup} // adding coordinator group from workflowbar to use here.
        peerReviewerName={peerReviewerName}
        requesterName={requesterName}
        userRole={userRole}
        network={network}
        coordinatorId={coordinatorId}
        peerReviewerId={peerReviewerId}
        remedyId={remedyId}
        rejectedFromPeer={rejectedFromPeer}
        requester={requester}
        statusReason={statusReason}
        impactValue={impactValue}
        changeAnalystCircuitCheckID={changeAnalystCircuitCheckID}
        userLoggedIn={userLoggedIn}
        otherLineOperator={otherLineOperator} // Passing OLO to workflow bar
        slaType={slaType}
        isIcmCrq={isIcmCrq}
      />
      <AssignToMeContent
        status={status}
        crqId={crqId}
        network={network}
        statusReason={statusReason}
        changeAnalystCircuitCheckID={changeAnalystCircuitCheckID}
        userLoggedIn={userLoggedIn}
        fetching={fetching}
        isChangeAnalyst={isChangeAnalyst}
      />
      {
        showInfoIcon && (
        <InfoIcon />
        )
      }
      {
        hasErrors && (
          <SummaryError
            errors={errors}
          />
        )
      }
      {
        getInfoMessageFlag && statusReason === '10500' && (
          <InfoIconSIA />
        )
      }
      {
        getInfoMessageFlag && statusReason === '10500' && (
          <SiaImportError
            getRemedyFailedStatusCR={getRemedyFailedStatusCR}
          />
        )
      }
      {
        isInCancelledStatus && (
          <CancelledStatusBar
            selectedNetwork={network}
            statusReason={statusReason}
            cancellationData={cancellationData}
          />
        )
      }
      {
        // Added negation to mobile comms SLA can approve to display the Comms SLA warning.
        (allSectionsRead && ((network === 'fixed' && commSLACanApprove) || (network === 'mobile' && mobileCommSLACanApprove)) && status === '5' && isOloService === false) && (
          <SectionError errorMsg="Comms SLA Missed" />
        )
      }
      <ViewCrqTabs
        openedTab={openedTab}
        setTab={setTab}
        canViewCompletionReview={canViewCompletionReview}
        formData={formData}
        impactValue={impactValue}
        network={network}
        showCrqAction
      />
      {
        openedTab === TAB_SECTION_SUMMARY && (
          <>
            <ViewCrqSectionSummary
              formData={formData}
              network={network}
              remedyId={remedyId}
              crqId={crqId}
              history={history}
              summarySectionsRead={summarySectionsRead}
              viewCrqPowers={viewCrqPowers}
              viewType={viewType}
              hasErrors={hasErrors}
              changeAnalystCircuitCheckID={changeAnalystCircuitCheckID}
              userLoggedIn={userLoggedIn}
              impactValue={impactValue} // sending for rescheduling page
              hasReferenceCRQ={hasReferenceCRQ}
            />
            { ((status === '3' && isAssignedCoordinator) || (status === '4' && isAssignedPeerReviewer && statusReason !== '10500') || (status === '5' && isApproverAssigned)) && (
              <div className="approver-note">
                Note: Please expand and review all the sections to enable the
                {(status === '5' || (status === '4')) ? ' approve ' : ' submit '}
                button.
              </div>
            )}
            {((status === '4' && statusReason === '10500' && isChangeAnalyst && !isInternationalCrq && !isEmergencyCrq) || (hasReferenceCRQ() === true)) && ( // visible only to user having change analyst access and non-Emergency CRQs
              <ViewCrqCreateRelatedNetwork
                formData={formData}
                realNetwork={network}
                isCreateMobileCrq={isCreateMobileCrq}
                hasReferenceCRQ={hasReferenceCRQ}
                isChangeAnalyst={isChangeAnalyst}
              />
            )}
            {
              (showCrqAction || showCrqActionBypass) && (
              <ViewCrqActions
                network={network}
                crqId={crqId}
                status={status}
                statusReason={statusReason ? statusReason : ''}
                userRole={userRole}
                isShowCrqAction={((isAssignedCoordinator && !isAssignedPeerReviewer) || isCoordinatorFromCMGroup)}
                enableCancelApproval={enableCancelApproval} // for dealing view-crq-nav while performing crq-actions in approval stage.
                enablePostponeApproval={enablePostponeApproval} // for dealing view-crq-nav while performing crq-actions in approval stage.
                isAssignedCoordinator
                isAssignedPeerReviewer
                impactValue={impactValue}
                commsStatusFlag={formData.comms_status_flag}
                postponeReason1={postponeReason1}
                postponeReason2={postponeReason2}
                postponeReason3={postponeReason3}
                riskValue={riskValue}
                hasReferenceCRQ={hasReferenceCRQ}
                remedyRefFormData={remedyRefFormData}
                isEmergencyCrq={isEmergencyCrq}
              />
              )
            }
          </>
        )
      }
      {
        openedTab === TAB_APPROVALS_HISTORY && (
          <>
            <ViewCrqApprovalsHistory
              formData={formData}
              canAddApprovers={canAddApprovers}
              userLoggedIn={userLoggedIn}
              userGroups={userGroups}
              crqId={crqId}
              isAssignedCoordinator={isAssignedCoordinator}
              hasApproverAssigned={hasApproverAssigned}
              isEmergencyCrq={isEmergencyCrq}
            />
            { status === '5' && isAssignedCoordinator && (otherLineOperator === 'No' || network === 'mobile') && (
              <div className="approver-note">Note: If you have recently added any additional approvers and they are not visible, please refresh the page.</div>
            )}
            {/* Here goes the component for Add Additional Approver Feature */}
            { canAddApprovers && otherLineOperator === 'No' && (
              <ViewCrqAddApprovers
                crqId={crqId}
                network={network}
              />
            )}
            { network === 'mobile' && isAssignedCoordinator && status === '5' && (
              <MobileIndividualApprovers
                crqId={crqId}
              />
            )}
          </>
        )
      }
      {/* {
        openedTab === TAB_COMMS_SUMMARY && (
          <>
            <ViewCrqCommsSummaryReview />
          </>
        )
      } */}
      {
        (openedTab === TAB_COMPLETION_REVIEW && canViewCompletionReview) && (
          <ViewCrqCompletionReview
            formData={formData}
            network={network}
            userRoles={userRoles}
            crqId={crqId}
            remedyId={remedyId}
          />
        )
      }
      {
        openedTab === TAB_COMMS_SUMMARY && (
          <ViewCrqCommsSummary
            formData={formData}
            notificationCommsSummaryData={notificationCommsSummaryData}
            network={network}
            remedyId={remedyId}
            crqId={crqId}
            history={history}
            summarySectionsRead={summarySectionsRead}
            viewCrqPowers={viewCrqPowers}
            viewType={viewType}
            hasErrors={hasErrors}
          />
        )
      }
      {
        openedTab === TAB_SECTION_SUMMARY && (!isEmergency2ndJourney2 || !isEmergencyCrq) && isInCoordinatorReviewStatus && canEditForm && (otherLineOperator !== 'Yes' && isOloService === false) && (adjacentRemedyRef === null || adjacentRemedyRef === undefined) && (
          <ViewCrqSelectPeerReviewer
            crqId={crqId}
            network={network}
          />
        )
      }
      {
        canSubmitForm && (
          <ViewCrqNav
            crqId={crqId}
            // Added additional condition of isOloService along with status to tackle the submit button for OLO CRQs.
            canSubmit={(status === '5' && !isOloService) ? canSubmitToPeer && ((network === 'fixed' && !isOloService) ? !commSLACanApprove : !mobileCommSLACanApprove) : canSubmitToPeer}
            // canSubmit={(formData.status === '5' && (isMobileCommsApprover() || isFixedCRBApprover())) ? canSubmitToPeer && (commSLACanApprove === true || mobileCommSLACanApprove === true) : canSubmitToPeer}
            slaCancelModal={isCancelChecked} // for dealing view-crq-nav while performing crq-actions in approval stage.
            slaPostponeModal={isPostponeChecked} // for dealing view-crq-nav while performing crq-actions in approval stage.
            status={status}
            statusReason={statusReason ? statusReason : ''}
            changeAnalystCircuitCheckID={changeAnalystCircuitCheckID}
            userLoggedIn={userLoggedIn}
            isChangeAnalyst={isChangeAnalyst}
            // isChangeAnalyst={isChangeAnalyst}
            postponeReason1={postponeReason1} // Sending for 3 times rescheduling limit
            postponeReason2={postponeReason2}
            postponeReason3={postponeReason3}
            otherLineOperator={otherLineOperator}
            isMobileYesFlag={isMobileYesFlag}
            serImpAssRemedyFlagAtCR={serImpAssRemedyFlagAtCR}
            hasReferenceCRQ={hasReferenceCRQ}
            remedyRefFormData={remedyRefFormData} // Sending ref crq formdata
            isCrqInfo={isCrqInfo}
            isEmergencyCrq={isEmergencyCrq}
          />
        )
      }
    </div>
  );
};

ViewCrqScreenContentUnconnected.propTypes = {
  network: PropTypes.string,
  crqId: PropTypes.string,
  userRoles: PropTypes.objectOf(PropTypes.string),
  remedyId: PropTypes.string,
  formData: formDataFromServerShape,
  history: ReactRouterPropTypes.history,
  summarySectionsRead: PropTypes.objectOf(PropTypes.bool),
  viewCrqPowers: PropTypes.objectOf(PropTypes.bool),
  approvalsContext: PropTypes.bool,
  isChangeAnalyst: PropTypes.bool, // isChangeAnalyst PropTypes checking
  userLoggedIn: PropTypes.string,
  changeAnalystCircuitCheckID: PropTypes.string,
  notificationCommsSummaryData: PropTypes.arrayOf(PropTypes.object),
  userGroups: PropTypes.objectOf(PropTypes.array),
  fetching: PropTypes.bool,
  remedyRefFormData: PropTypes.objectOf(PropTypes.string),
};



const mapStateToProps = (state, ownProps) => {
  // const {
  //   crqId,
  // } = ownProps;
  const userLoggedInCheck = state && state.auth && state.auth.user && state.auth.user.id;
  return ({
    isChangeAnalyst: state && state.auth.isChangeAnalyst,
    userLoggedIn: userLoggedInCheck,
    // isChangeAnalyst: state && state.auth.isChangeAnalyst,
    userGroups: state && state.auth.user.groups,
    remedyRefFormData: (state.remedyReferenceCrq === undefined && (Object.keys(state.remedyReferenceCrq).length === 0)) ? null : state.remedyReferenceCrq.crqData,
  });
};



const ViewCrqScreenContent = connect(
  mapStateToProps,
)(ViewCrqScreenContentUnconnected); // Wrapping method SectionSummaryHeaderConnect within Connect

export {
  ViewCrqScreenContent,
};
